// Filter bed data based on search text, ward and status filters
export const filterBeds = (bedsData, searchText, wardFilter, statusFilter) => {
  return bedsData.filter((bed) => {
    // Text search
    const textMatch =
      searchText === '' ||
      (bed.patientAssigned && bed.patientAssigned.toLowerCase().includes(searchText.toLowerCase())) ||
      bed.bedId.toLowerCase().includes(searchText.toLowerCase()) ||
      bed.roomNumber.toLowerCase().includes(searchText.toLowerCase())

    // Ward filter
    const wardMatch = wardFilter === 'all' || bed.ward === wardFilter

    // Status filter
    const statusMatch = statusFilter === 'all' || bed.bedStatus === statusFilter

    return textMatch && wardMatch && statusMatch
  })
}

// Group beds by ward for summary view
export const getWardSummary = (bedsData, wards) => {
  return wards.map((ward) => {
    const bedsInWard = bedsData.filter((bed) => bed.ward === ward)
    const totalBeds = bedsInWard.length
    const occupiedBeds = bedsInWard.filter((bed) => bed.bedStatus === 'Occupied').length
    const availableBeds = bedsInWard.filter((bed) => bed.bedStatus === 'Available').length
    const cleaningBeds = bedsInWard.filter((bed) => bed.bedStatus === 'Cleaning').length

    return {
      ward,
      totalBeds,
      occupiedBeds,
      availableBeds,
      cleaningBeds,
      occupancyRate: totalBeds > 0 ? Math.round((occupiedBeds / totalBeds) * 100) : 0
    }
  })
}
